<script lang="ts">
	import { T } from '@tolgee/svelte';
</script>

<div class="font-bold text-h-24">
	<T keyName="customer.noOrder.title" />
</div>
<div class="text-p-16">
	<T keyName="customer.noOrder.description" />
</div>
